import React from 'react';
import { Footer } from 'rsuite';

function FooterComponent() {
  return <Footer className="db-footer text-center">Copyright © 2023 Realsage - All Rights Reserved.</Footer>;
}

export default FooterComponent;
